<template>
	<div>

		<div class="main-container">

			<div class="navBarTest">
				<Navbar />
			</div>

			<!-- Page Title Banner -->
			<div class="secondary-title-wrapper col-lg-12" style="border-bottom: solid #007cc3">
				<h1 class="h3 my-0 mx-lg-5 secondary-title">{{ $t('wj51c.mainTitle') }}</h1>
			</div>

            <!-- Main -->
			<section class="container-fluid">
                <div class="container" style="max-width: 1500px">
                    <div class="row align-items-end">
                        <div class="col-lg-6 mb-4 mb-lg-0 text-center order-2 order-lg-1">
                            <img src="../assets/img/3d/wj51c-tabletop.png" alt="Flashforge WJ51C" class="img-fluid" style="max-height: 600px;">
                        </div>
                        
                        <div class="col-lg-6 order-1 order-lg-2 mt-5 mb-0 mb-lg-5">
                            <h2 class="font-weight-bold mb-3" style="color: #333;">Flashforge WJ51C</h2>
                            <h4 class="text-primary mb-4 pl-0">{{ $t('wj51c.highPrecisionWax') }}</h4>
                            <p class="lead text-muted" v-html="$t('wj51c.mainText')"></p>
                            <div class="mt-4">
                                <a href="#formulaire" class="btn btn-primary btn-lg shadow-sm px-5" style="background-color: #007cc3; border: none;"
                                 onmouseover="this.style.color='white'">
                                    {{ $t('wj51c.preorderNow') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Compare Table -->
            <section class="container-fluid py-5 bg-light">
                <div class="container">
                <div class="row text-center mb-5">
                    <div class="col-12">
                        <h2 class="font-weight-bold">WJ51C vs. {{ $t('wj51c.industryStandards') }}</h2>
                        <p class="text-muted">{{ $t('wj51c.investment') }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 mb-4">
                        <div class="card h-100 shadow-sm border-0">
                            <div class="card-header bg-primary text-white font-weight-bold py-3 text-center" style="background-color: #007cc3 !important">
                                WJ51C VS SolidScape
                            </div>
                            <div class="card-body">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-arrow-up text-success mr-3"></i> 
                                        {{ $t('wj51c.comp1') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-dollar-sign text-success mr-3"></i> 
                                        {{ $t('wj51c.comp2') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-expand-arrows-alt text-success mr-3"></i> 
                                        {{ $t('wj51c.comp3') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-tags text-success mr-3"></i> 
                                        {{ $t('wj51c.comp4') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-leaf text-success mr-3"></i> 
                                        {{ $t('wj51c.comp5') }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                        <div class="card h-100 shadow-sm border-0">
                            <div class="card-header bg-primary text-white font-weight-bold py-3 text-center" style="background-color: #007cc3 !important">
                                WJ51C VS 3DSystems
                            </div>
                            <div class="card-body">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-compress-arrows-alt text-success mr-3"></i> 
                                        {{ $t('wj51c.comp6') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-diamond text-success mr-3"></i> 
                                        {{ $t('wj51c.comp7') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-chart-line text-success mr-3"></i> 
                                        {{ $t('wj51c.comp8') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-tags text-success mr-3"></i> 
                                        {{ $t('wj51c.comp9') }}</li>
                                    <li class="list-group-item d-flex align-items-center"><i class="fas fa-check-circle text-success mr-3"></i> 
                                        {{ $t('wj51c.comp10') }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </section>

            <!-- Jewelry -->
            <section class="container py-5">
                <div class="row align-items-center">
                    <div class="col-lg-6 order-2 order-lg-1">
                        <h2 class="font-weight-bold mb-4">{{ $t('wj51c.madeFor') }}</h2>
                        <p>{{ $t('wj51c.allowsFor') }}</p>
                        <ul class="list-unstyled">
                            <li class="mb-2"><i class="fas fa-chevron-right text-primary mr-2"></i> 
                                {{ $t('wj51c.massProduction') }}
                            </li>
                            <li class="mb-2"><i class="fas fa-chevron-right text-primary mr-2"></i> 
                                {{ $t('wj51c.hansFree') }}
                            </li>
                            <li class="mb-2"><i class="fas fa-chevron-right text-primary mr-2"></i> 
                               {{ $t('wj51c.reductionPhrase') }} 
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0 text-center">
                        <img src="../assets/img/3d/floral-ring.png" alt="Jewelry Wax Pattern" class="img-fluid" style="max-height:400px">
                    </div>
                </div>
            </section>

            <!-- Cards -->
            <section class="container-fluid py-5 bg-light">
                <div class="container">
                    <div class="row text-center mb-5">
                        <div class="col-12">
                            <h2 class="display-5 font-weight-bold">{{ $t('wj51c.keyAdvantages') }}</h2>
                            <hr style="width: 60px; border-top: 3px solid #007cc3; margin: 20px auto;">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 mb-4">
                            <div class="card h-100 border-0 shadow-sm p-4 transition-card" style="border-bottom: 4px solid transparent !important; border-radius: 10px;">
                                <div class="mb-3">
                                    <i class="fas fa-gem fa-2x text-primary"></i>
                                </div>
                                <h5 class="font-weight-bold mb-3" style="color: #333;">{{ $t('wj51c.ultraSmooth') }}</h5>
                                <p class="small text-muted mb-0" style="line-height: 1.6;">{{ $t('wj51c.achievePhrase') }}</p>
                            </div>
                        </div>

                        <div class="col-md-4 mb-4">
                            <div class="card h-100 border-0 shadow-sm p-4 transition-card" style="border-bottom: 4px solid transparent !important; border-radius: 10px;">
                                <div class="mb-3">
                                    <i class="fas fa-fire fa-2x text-primary"></i>
                                </div>
                                <h5 class="font-weight-bold mb-3" style="color: #333;">{{ $t('wj51c.castable') }}</h5>
                                <p class="small text-muted mb-0" style="line-height: 1.6;">{{ $t('wj51c.proCasting') }}</p>
                            </div>
                        </div>

                        <div class="col-md-4 mb-4">
                            <div class="card h-100 border-0 shadow-sm p-4 transition-card" style="border-bottom: 4px solid transparent !important; border-radius: 10px;">
                                <div class="mb-3">
                                    <i class="fas fa-industry fa-2x text-primary"></i>
                                </div>
                                <h5 class="font-weight-bold mb-3" style="color: #333;">{{ $t('wj51c.industrial') }}</h5>
                                <p class="small text-muted mb-0" style="line-height: 1.6;">{{ $t('wj51c.builtFor') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Space Saving -->
            <section class="container py-5 bg-white border-top">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <h6 class="text-primary font-weight-bold text-uppercase mb-2" style="letter-spacing: 1px;">{{ $t('wj51c.space') }}</h6>
                        <h2 class="font-weight-bold mb-4">{{ $t('wj51c.footprint') }}</h2>
                        <p class="text-muted mb-4">
                            {{ $t('wj51c.traditionalPhrase') }}
                        </p>
                        
                        <div class="d-flex mb-4">
                            <div class="mr-4">
                                <div class="h3 font-weight-bold mb-0">865mm</div>
                                <small class="text-uppercase text-muted">{{ $t('wj51c.width') }}</small>
                            </div>
                            <div class="mr-4" style="border-left: 1px solid #dee2e6; padding-left: 1.5rem;">
                                <div class="h3 font-weight-bold mb-0">510mm</div>
                                <small class="text-uppercase text-muted">{{ $t('wj51c.depth') }}</small>
                            </div>
                            <div style="border-left: 1px solid #dee2e6; padding-left: 1.5rem;">
                                <div class="h3 font-weight-bold mb-0">115kg</div>
                                <small class="text-uppercase text-muted">{{ $t('wj51c.weight') }}</small>
                            </div>
                        </div>

                        
                    </div>

                    <div class="col-lg-6 pl-lg-5 mt-5 mt-lg-0">
                        <ul class="list-unstyled shadow-sm p-4 rounded border-left" style="border-left: 5px solid #007cc3 !important; background-color: #fcfcfc;">
                            <li class="mb-3 d-flex align-items-start">
                                <i class="fas fa-expand-arrows-alt text-primary mt-1 mr-3"></i>
                                <span><strong>{{ $t('wj51c.eliminates') }}</strong> {{ $t('wj51c.fitsPhrase') }}</span>
                            </li>
                            <li class="d-flex align-items-start">
                                <i class="fas fa-layer-group text-primary mt-1 mr-3"></i>
                                <span><strong>{{ $t('wj51c.scalable') }}</strong> {{ $t('wj51c.compactPhrase') }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Specifications -->
            <section class="container-fluid py-5 bg-light">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-10 mx-auto">
                            <h2 class="mb-4 font-weight-bold border-left pl-3" style="border-left: 5px solid #007cc3 !important;">
                                {{ $t('wj51c.technical') }}
                            </h2>
                            <div class="table-responsive shadow-sm">
                                <table class="table table-bordered mb-0 bg-white">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th scope="col" class="bg-dark text-white">{{ $t('wj51c.feature') }}</th>
                                            <th scope="col" class="bg-dark text-white">{{ $t('wj51c.spec') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th class="bg w-25">{{ $t('wj51c.buildVolume') }}</th>
                                            <td>235 x 138 x 100 mm</td>
                                        </tr>
                                        <tr>
                                            <th class="bg">{{ $t('wj51c.dimAcc') }}</th>
                                            <td>± 0.04 mm / 20 mm</td>
                                        </tr>
                                        <tr>
                                            <th class="bg">{{ $t('wj51c.resolution') }}</th>
                                            <td>{{ $t('wj51c.resSpec') }}</td>
                                        </tr>
                                        <tr>
                                            <th class="bg">{{ $t('wj51c.tech') }}</th>
                                            <td>{{ $t('wj51c.mjp') }}</td>
                                        </tr>
                                        <tr>
                                            <th class="bg">{{ $t('wj51c.matSpec') }}</th>
                                            <td>{{ $t('wj51c.highPrec') }} (FFWJ1200, FFMS3200)</td>
                                        </tr>
                                        <tr>
                                            <th class="bg">{{ $t('wj51c.connectivity') }}</th>
                                            <td>{{ $t('wj51c.connSpecs') }}</td>
                                        </tr>
                                        <tr>
                                            <th class="bg">{{ $t('wj51c.slicing') }}</th>
                                            <td>WaxJetPrint</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Form -->
            <section id="formulaire" class="container-fluid py-5" style="background-color: #f8fbfd;">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 text-center mb-1">
                            <h2 class="font-weight-bold">{{$t('wj51c.interested')}}</h2>
                            <p class="text-muted">{{$t('wj51c.contactTeam')}}</p>
                        </div>
                    </div>
                    
                    <div class="row align-items-center">
                        <div class="col-lg-6 mb-4 mb-lg-0 text-center order-2 order-lg-1">
                            <img src="../assets/img/3d/front-wj51c.png" 
                                 alt="Flashforge WJ51C Front" 
                                 class="img-fluid rounded" 
                                 style="max-height: 450px;">
                            <img src="../assets/img/3d/back-wj51c.png" 
                                 alt="Flashforge WJ51C Back" 
                                 class="img-fluid rounded" 
                                 style="max-height: 450px;">
                        </div>

                        <div class="col-lg-6 order-1 order-lg-2">
                            <ContactForm 
                                style="background-color:white" 
                                :use-shadow="true" 
                                :boolEmbeded="true" 
                                :serviceOptions="[{ value: $t('wj51c.formOption1'), label: $t('wj51c.formOption1') }]" 
                            />
                        </div>
                    </div>
                </div>
            </section>

		</div>

		<div>
			<FooterMain />
		</div>
	</div>
</template>

<script>
	import Navbar from '../components/Navbar.vue'
    import ContactForm from '../components/ContactForm.vue'
	import FooterMain from '../components/FooterMain.vue'

	export default {
		name: 'WJ51C',
		components: {
			Navbar,
            ContactForm,
			FooterMain
		},
		metaInfo(){
			return {
				title: this.$i18n.t('tabTitle.wj51c'),
				meta: [
					{ "name": "description", "content":  this.$i18n.t('meta.description.wj51c') },
					{ "name": "theme-color", "content": "#007BFF;" }
				]
			}
		},
		created(){
			if(typeof window.gtag !== 'undefined'){
				window.gtag('config', process.env.VUE_APP_GTAG_UA, {
						'page_title' : this.$i18n.t('tabTitle.wj51c'),
						'page_path': this.$i18n.t('links.wj51c')
				});
				window.gtag('config', process.env.VUE_APP_GTAG_G, {
						'page_title' : this.$i18n.t('tabTitle.wj51c'),
						'page_path': this.$i18n.t('links.wj51c')
				});
			}
			if(typeof window.fbq !== 'undefined'){
				window.fbq('track', 'PageView');
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/scss/variabls.scss';
	@import '../assets/scss/elements/page-equipements.scss';


	#formulaire {
		scroll-margin-top: 100px; /* adjust to your header height */
	}

</style>